import React from 'react';
import { NetworkStatus, useMutation } from '@apollo/client';
import { CircularProgress, LinearProgress, TablePagination, TableRow, TableHead, TableContainer, TableCell, TableBody, Table, IconButton, Link } from "@mui/material";
import LocalProvider from "../../../../components/LocalProvider";
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { DELETE_ADMIN, DELETE_COMMON_FILE } from '../../../../graphql/mutations'

export default function List({ loading, error, data, networkStatus, currentPage, setCurrentPage, rowsPerPage, setRowsPerPage, onEdit, onDelete }) {

  // Setup mutation
  const [deleteCommonFile, { loading: loadingDelete }] = useMutation(DELETE_COMMON_FILE);

  if (loading) return <CircularProgress style={{ margin: 12 }} />;
  if (error) return <div>{error}</div>;

  const handleDelete = (item) => {

    deleteCommonFile({ 
      variables: { 
        id: item.id 
      } 
    })
    .then(() => onDelete())
  }

  return (
    <>
      <TableContainer>
        {networkStatus === NetworkStatus.refetch && <LinearProgress />}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Arquivo</TableCell>
              <TableCell>Tema</TableCell>
              <TableCell>&nbsp;</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              data.fetchCommonFile.data.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>
                    <Link href={ row.path }>{row.name}</Link>
                  </TableCell>
                  <TableCell>{row.theme}</TableCell>
                  <TableCell style={{ textAlign: 'right' }}>
                    <IconButton 
                      style={{ padding: 0 }} 
                      aria-label="delete" 
                      onClick={() => handleDelete(row)}>
                      { loadingDelete ? <CircularProgress size={21} /> : <DeleteIcon />}
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            }

            {
              data.fetchCommonFile.data.length == 0 &&
              <TableRow>
                <TableCell colSpan={3}>Nenhum conteúdo cadastrado</TableCell>
              </TableRow>
            }

          </TableBody>
        </Table>
      </TableContainer>

      <LocalProvider locale="ptBR">
        <TablePagination
        	showFirstButton
          showLastButton        
          rowsPerPageOptions={[8, 15, 32, 100]}
          component="div"
          count={data.fetchCommonFile.total}
          rowsPerPage={rowsPerPage}
          page={currentPage}
          onPageChange={(event, newPage) => {
            setCurrentPage(newPage);
          }}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setCurrentPage(0);
          }}
        />
      </LocalProvider>
    </>
  );
}